export const resolveDefaultWorkspace = ({ workspaces = [], authUser = null } = {}) => {
  if (!Array.isArray(workspaces) || authUser?.id == null) {
    return null;
  }

  return (
    workspaces.find(
      workspace =>
        workspace?.is_default === true && String(workspace.owner_identity_user_id ?? "") === String(authUser.id)
    ) || null
  );
};
